import { useTheme, useMediaQuery } from '@mui/material';

export enum GridMultiplier {
  MOBILE = 12,
  SMALL = 6,
  MEDIUM = 4,
  LARGE = 3,
}

/** Responsive grid sizing based on GridMultiplier breakpoints */
export const getFieldGridSize = (fieldColumns: number | undefined | null) => {
  const cols = fieldColumns ?? 1;
  return {
    xs: 12,
    sm: Math.min(cols * GridMultiplier.SMALL, 12),
    md: Math.min(cols * GridMultiplier.MEDIUM, 12),
    lg: Math.min(cols * GridMultiplier.LARGE, 12),
  };
};

export const useGetScreenSize = (): {
  gridMultiplier: number;
  isMobileScreen: boolean;
  isSmallScreen: boolean;
  isMediumScreen: boolean;
  isMobileOrSmallScreen: boolean;
} => {
  const theme = useTheme() as any;
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  let gridMultiplier = GridMultiplier.LARGE;
  if (isMediumScreen) {
    gridMultiplier = GridMultiplier.MOBILE;
  }
  if (isSmallScreen) {
    gridMultiplier = GridMultiplier.SMALL;
  }
  if (isMobileScreen) {
    gridMultiplier = GridMultiplier.LARGE;
  }

  return {
    gridMultiplier,
    isMediumScreen,
    isSmallScreen,
    isMobileScreen,
    isMobileOrSmallScreen: isMobileScreen || isSmallScreen,
  };
};
